import classNames from 'classnames';
import { ButtonSize, TextInputSize } from 'lego-on-react';
import * as React from 'react';
import { KeyboardEvent } from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { KeyCode } from '../../../typings/common';
import { ButtonDecorator } from '../../ButtonDecorator/ButtonDecorator';
import { TextInputDecorator } from '../../TextInputDecorator/TextInputDecorator';

import './PhrasesSelectorWizardInput.css';

interface PhrasesSelectorWizardInputProps {
    cls?: string;
    value: string;
    onChange: (value: string) => void;
    onSubmit: () => void;
    placeholder: string;
    buttonText: string;
    buttonSize: ButtonSize;
    inputSize: TextInputSize;
}

export class PhrasesSelectorWizardInput extends React.PureComponent<
    PhrasesSelectorWizardInputProps
> {
    render() {
        const {
            value,
            onChange,
            placeholder,
            buttonText,
            onSubmit,
            buttonSize,
            inputSize,
            cls
        } = this.props;

        return (
            <div
                className={classNames(
                    cls,
                    Bem.cls('phrases-selector-wizard-input')
                )}
            >
                <TextInputDecorator
                    text={value}
                    theme={'normal'}
                    view={'classic'}
                    size={inputSize}
                    onChange={onChange}
                    onKeyDown={this.onWordInputKeydown}
                    placeholder={placeholder}
                    pin={'brick-clear'}
                />
                <ButtonDecorator
                    cls={Bem.cls('phrases-selector-wizard-input', 'button')}
                    theme={'action'}
                    size={buttonSize}
                    width={'max'}
                    text={buttonText}
                    onClick={onSubmit}
                    pin={'clear-round'}
                />
            </div>
        );
    }

    private onWordInputKeydown = (e: KeyboardEvent<HTMLDivElement>) => {
        const { onSubmit } = this.props;

        const code = e.keyCode;

        if (code === KeyCode.RETURN) {
            onSubmit();
        }
    };
}
